import { render, staticRenderFns } from "./RichTextContent.vue?vue&type=template&id=b789201c&scoped=true&"
import script from "./RichTextContent.vue?vue&type=script&lang=js&"
export * from "./RichTextContent.vue?vue&type=script&lang=js&"
import style0 from "./RichTextContent.vue?vue&type=style&index=0&id=b789201c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b789201c",
  null
  
)

export default component.exports